export { default as Pricing } from './Pricing';
export { default as Faq } from './Faq';
export { default as CompanyTerms } from './CompanyTerms';
